var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1712654238640,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 6041,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0.02249C229.259773 0.02249 0 229.237284 0 512s229.237284 511.97751 512 511.97751c282.785206 0 512-229.214794 512-511.97751S794.785206 0.02249 512 0.02249z m0 153.087235a169.347272 169.347272 0 1 1 0.02249 338.694545 169.347272 169.347272 0 0 1-0.02249-338.694545z m-0.112448 737.009224a375.757533 375.757533 0 0 1-244.687693-90.228586 72.169375 72.169375 0 0 1-25.323377-54.852324c0-94.83897 76.75727-170.741632 171.61873-170.741632h197.054555c94.88395 0 171.348854 75.902662 171.348854 170.741632a71.966968 71.966968 0 0 1-25.300888 54.829834 375.622595 375.622595 0 0 1-244.710181 90.251076z",
    "p-id": 6042,
    fill: "#bfbfbf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9f19669ad9546f41a7d52574a6532087.svg";
export { ForwardRef as ReactComponent };